<template>
  <v-container fluid>
    <div>
      <v-alert
        v-model="deleteConfirmationAlert"
        outline
        type="success"
      >WorkOrder Successfully Deleted</v-alert>
      <v-alert
        v-model="createConfirmationAlert"
        outline
        type="success"
      >WorkOrder Successfully Created</v-alert>
      <v-alert v-model="typeModifiedAlert" outline type="success">WorkOrder Type Modified</v-alert>
      <v-toolbar
        :color="getColor(primaryWorkOrder.type)"
        :light="!getTheme(primaryWorkOrder.type)"
        :dark="getTheme(primaryWorkOrder.type)"
      >
        <v-flex xs4>
          <v-icon color="primary" @click="goBack">chevron_left</v-icon>
          <v-btn v-if="canShowSave()" color="primary" @click="updateWO">SAVE / UPDATE</v-btn>
        </v-flex>
        <v-flex xs4>
          <h2
            class="text-xs-center"
            v-if="primaryWorkOrder.type ==='SCP'"
          >SCP {{primaryWorkOrder.id}}</h2>
          <h2 class="text-xs-center" v-else>WORKORDER {{primaryWorkOrder.id}}</h2>
        </v-flex>
        <v-flex xs3></v-flex>
        <v-flex xs1>
          <v-btn color="primary" @click="printPDF">PRINT PDF</v-btn>
        </v-flex>
      </v-toolbar>
      <br />
      <div v-if="loaded">
        <v-layout row>
          <v-flex xs5>
            <WOLeftPanel :wo="primaryWorkOrder" :lock="lock" v-on:woChanged="woChanged"></WOLeftPanel>
            <div v-if="primaryWorkOrder.type !== 'SCP'"></div>
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs6>
            <WOInfoPanel
              :wo="primaryWorkOrder"
              v-on:inventoryUpdated="inventoryUpdated"
              v-if="primaryWorkOrder.type !== 'SCP'"
            ></WOInfoPanel>
            <WOInfoPanel
              :wo="primaryWorkOrder"
              v-on:inventoryUpdated="inventoryUpdated"
              :omit="true"
              v-else
            ></WOInfoPanel>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <div v-if="primaryWorkOrder.type !== 'LAB TEST'
                         && primaryWorkOrder.type !== 'SCP' && primaryWorkOrder.type !== 'BLENDING'">
              <br />
              <label>INSTRUCTIONS:</label>
              <br />
              <textarea
                rows="10"
                cols="175"
                name="description"
                style="border:solid 2px white"
                label="INSTRUCTIONS"
                v-model="description"
              ></textarea>
            </div>
          </v-flex>
        </v-layout>
        <!-- <div v-if="primaryWorkOrder.type !== 'BLENDING' & primaryWorkOrder.type !== 'LAB TEST'">
          <v-text-field
            textarea
            outline
            v-if="showCompletionComments || completionCommentsExist"
            name="input-7-4"
            label="Completion Comments!"
            v-model="primaryWorkOrder.completionDescription"
          ></v-text-field>
        </div>-->
        <v-layout justify-start>
          <div
            v-if="primaryWorkOrder.type !== 'LAB TEST' && primaryWorkOrder.type
             !== 'BLENDING' && primaryWorkOrder.type !== 'SCP' && primaryWorkOrder.type !== 'BOTTLING'"
          >
          <v-checkbox
            v-if="!completionCommentsExist"
            v-model="showCompletionComments"
            label="Completion Comments"
          ></v-checkbox>
          </div>
        </v-layout>
        <v-layout row>
              <div v-if="primaryWorkOrder.type !== 'LAB TEST'
                         && primaryWorkOrder.type !== 'SCP' && primaryWorkOrder.type !== 'BLENDING'">
              <br />
              <label v-if="showCompletionComments || completionCommentsExist"

              >COMPLETION COMMENTS:</label>
              <br />
              <textarea
                rows="10"
                cols="175"
                name="description"
                style="border:solid 2px white"
                v-if="showCompletionComments || completionCommentsExist"
                label="COMPLETION COMMENTS"
                v-model="primaryWorkOrder.completionDescription"
              ></textarea>
            </div>
        </v-layout>
      </div>
      <br />
      <div v-if="primaryWorkOrder.type === 'BOTTLING'">
        <bottling :wo="primaryWorkOrder" v-on:bottlingRecordsUpdated="bottlingRecordsUpdated"></bottling>
      </div>
      <div v-if="primaryWorkOrder.type === 'SCP'">
        <SCP :wo="primaryWorkOrder" v-on:scpUpdated="scpUpdated"></SCP>
      </div>
      <div v-if="primaryWorkOrder.type === 'LAB TEST'">
        <LabTests
          :wo="primaryWorkOrder"
          v-on:labsUpdated="labsUpdated"
          v-on:deletedLabsUpdated="deletedLabsUpdated"
        ></LabTests>
      </div>
      <!-- <div v-if="primaryWorkOrder.type === 'TOPPING'">
        <LotListTopping
          :selectedLots="lotsList"
          :date="primaryWorkOrder.date"
          v-on:workOrderTapped="workOrderTapped"
          v-on:lotsUpdated="toppingLotsUpdated"
          :primaryLot="primaryWorkOrder.Lot.lotNumber"
        ></LotListTopping>
      </div> -->
      <div v-if="primaryWorkOrder.type === 'BLENDING'">
        <LotListBlending
          :selectedLots="lotsList"
          :wo="primaryWorkOrder"
          :date="primaryWorkOrder.date"
          v-on:blendingLotsUpdated="blendingLotsUpdated"
        ></LotListBlending>
      </div>
      <v-layout row v-if="primaryWorkOrder.id >= 0">
        <v-flex xs2></v-flex>
        <v-flex xs8>
          <v-layout justify-center>
            <v-btn
              v-if="primaryWorkOrder.type != 'SCP'"
              @click="deleteWO"
              dark
              color="red accent-4"
            >DELETE WORKORDER</v-btn>
            <v-btn v-else @click="deleteWO" dark color="red">DELETE SCP</v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>
<script>
import axios from 'axios'
import { clean } from '../utilities/clean'
import utf8 from 'utf8'
import moment from 'moment'
import SCP from './SCP'
import WOInfoPanel from './WOInfoPanel'
import WOLeftPanel from './WOLeftPanel'
import Bottling from './Bottling'
import LabTests from './LabTests'
import LotListTopping from './LotListTopping'
import LotListBlending from './LotListBlending'
import myMixins from '../mixins/myMixins'
import { setTimeout } from 'timers'
export default {
  components: {
    WOLeftPanel,
    WOInfoPanel,
    Bottling,
    SCP,
    LabTests,
    LotListTopping,
    LotListBlending
  },
  data () {
    return {
      lock: false,
      emitCount: 0,
      updateInProgress: false, // chris is reporting some double wo creations so want to prevent a double tap
      deleteConfirmationAlert: false,
      createConfirmationAlert: false,
      typeModifiedAlert: false,
      loaded: false,
      menu: false,
      showCompletionComments: false,
      showSection: '',
      workers: [
        { text: 'PDC STAFF', value: 'CCC' },
        { text: 'CLIENT', value: 'CLIENT' }
      ],
      workOrderStatuses: ['ASSIGNED', 'COMPLETED'],
      workOrderTypes: [
        'ADDITION',
        'BLEED OFF',
        'BBL DOWN',
        'BLENDING',
        'BOTTLING',
        'FILTRATION',
        'HEAT TANK',
        'LAB TEST',
        'OTHER',
        'PRESSOFF',
        'PULL SAMPLE',
        'RACKING',
        'SCP',
        'SETTLING',
        'TOPPING'
      ],
      primaryWorkOrder: {
        type: ''
      },
      multiLotWorkOrders: [],
      labs: [],
      deletedLabs: [],
      dataByKey: {},
      lotsList: [],
      color: 'blue',
      performedByCCC: true,
      clientCode: ''
    }
  },
  mixins: [myMixins],
  created () {
    this.lock = this.$route.query.lock
    if (this.$route.params.id === '-1') {
      // this means it is a new workorder
      this.primaryWorkOrder.clientCode = this.$store.state.client.CODE
      if (this.$route.query.date) {
        this.primaryWorkOrder.date = moment(
          this.$route.query.date
        ).toISOString()
      } else {
        this.primaryWorkOrder.date = moment().toISOString()
      }
      this.primaryWorkOrder.Lot = this.$store.state.lot
      this.primaryWorkOrder.lot = this.$store.state.lot.lotNumber
      this.primaryWorkOrder.requestor = this.$store.state.user.username
      this.primaryWorkOrder.SCPs = []
      this.showLabTests = false
      this.primaryWorkOrder.workPerformedBy = 'CCC'
      this.primaryWorkOrder.taskId = -1
      this.primaryWorkOrder.status = 'ASSIGNED'
      if (this.$route.query.type) {
        this.updateType(this.$route.query.type)
      } else {
        this.updateType('OTHER')
      }
      let $this = this
      this.updateVolume(
        this.primaryWorkOrder.lot,
        this.primaryWorkOrder.date,
        function (structure) {
          $this.primaryWorkOrder.structure = structure.structure
          $this.primaryWorkOrder.structureTree = structure.structureTree
          $this.loaded = true
        }
      )
    } else {
      this.retrieveWorkOrder(this.$route.query.id)
    }
  },
  methods: {
    workOrderTapped (wo) {
      console.log('workorder tapped: ' + wo.woId)
      this.retrieveWorkOrder(wo.woId)
      // this.$router.replace({
      //   path: '/workorder',
      //   query: {
      //     id: wo.woId,
      //     test: 1234
      //   }
      // })
    },
    canShowSave () {
      if (this.primaryWorkOrder.type === 'BLENDING') {
        if (this.primaryWorkOrder.BlendItems) {
          if (this.primaryWorkOrder.BlendItems.length > 0) {
            return true
          }
          return false
        }
        return false
      }
      if (this.emitCount > 0) {
        if (this.primaryWorkOrder.lot) {
          if (this.primaryWorkOrder.type === 'SCP') {
            let scp = this.primaryWorkOrder.SCPs[0]
            if (scp.varietal && scp.vineyardid) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        }
      }
      return false
    },
    hasPDFPrintCapability () {
      if (!this.primaryWorkOrder.id || this.primaryWorkOrder.id === -1) {
        return false
      }
      return (
        this.primaryWorkOrder.type === 'TOPPING' ||
        this.primaryWorkOrder.type === 'PULL SAMPLE' ||
        this.primaryWorkOrder.type === 'OTHER' ||
        this.primaryWorkOrder.type === 'PRESSOFF' ||
        this.primaryWorkOrder.type === 'ADDITION' ||
        this.primaryWorkOrder.type === 'SCP' ||
        this.primaryWorkOrder.type === 'RACKING' ||
        this.primaryWorkOrder.type === 'BOTTLING'
      )
    },
    printPDF () {
      let url =
        process.env.VUE_APP_BACKEND +
        'workorders/' +
        this.primaryWorkOrder.id +
        '?pdf=true'
      console.log(url)
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      )
    },
    updateVolume (lot, date, complete) {
      let url =
        process.env.VUE_APP_BACKEND +
        'workorders?lot=' +
        lot +
        '&upToDate=' +
        date +
        '&finalStructOnly=true'
      console.log('calling: ' + url)

      axios.get(url).then(response => {
        complete(response.data.data)
      })
    },
    scpUpdated () {
      this.emitCount++
    },
    bottlingRecordsUpdated (records) {
      console.log(JSON.stringify(this.primaryWorkOrder, null, 2))
      this.emitCount++
    },
    inventoryUpdated (wo) {
      this.primaryWorkOrder = wo
      console.log(JSON.stringify(this.primaryWorkOrder, null, 2))
      this.emitCount++
    },
    woChanged (wo) {
      this.updateType(wo.type)
      this.primaryWorkOrder.lot = wo.Lot.lotNumber
    },
    deletedLabsUpdated (value) {
      this.deletedLabs = value
      this.emitCount++
      console.log('deleted labs ---')
      console.log(JSON.stringify(this.deletedLabs, null, 2))
      console.log('-------------')
    },
    labsUpdated (value) {
      console.log(JSON.stringify(value, null, 2))
      this.labs = value
      this.emitCount++
      //   console.log(JSON.stringify(this.labs, null, 2))
    },
    blendingLotsUpdated (value) {
      // console.log(JSON.stringify(this.primaryWorkOrder, null, 2))
      this.primaryWorkOrder.BlendItems = []
      let $this = this
      Object.keys(value).forEach(lot => {
        if (value[lot].isSelected) {
          $this.primaryWorkOrder.BlendItems.push({
            blendId: $this.primaryWorkOrder.blendId,
            id: value[lot].id,
            direction: 'IN FROM',
            gallons: value[lot].gallons,
            sourceLot: lot
          })
        }
      })
    },
    toppingLotsUpdated (value) {
      this.emitCount++
      Object.keys(value).forEach(key => {
        value[key].date = this.primaryWorkOrder.date
        value[key].type = this.primaryWorkOrder.type
        value[key].isComplete = this.primaryWorkOrder.isComplete
        value[key].status = this.primaryWorkOrder.status
        value[key].workPerformedBy = this.primaryWorkOrder.workPerformedBy
      })
      this.dataByKey = value
    },
    deleteWO () {
      if (this.primaryWorkOrder.type === 'SCP') {
        axios
          .delete(
            process.env.VUE_APP_BACKEND +
              'scps/' +
              this.primaryWorkOrder.SCPs[0].id
          )
          .then(response => {})
      }
      if (this.primaryWorkOrder.type === 'LAB TEST') {
        if (this.primaryWorkOrder.LabTests.length > 0) {
          axios
            .delete(
              process.env.VUE_APP_BACKEND +
                'labTests/' +
                this.primaryWorkOrder.LabTests[0].id
            )
            .then(response => {})
        }
        if (this.primaryWorkOrder.LabResults) {
          this.primaryWorkOrder.LabResults.forEach(function (result) {
            axios
              .delete(process.env.VUE_APP_BACKEND + 'labResults/' + result.id)
              .then(response => {})
          })
        }
      }
      axios
        .delete(
          process.env.VUE_APP_BACKEND + 'workorders/' + this.primaryWorkOrder.id
        )
        .then(response => {
          this.deleteConfirmationAlert = true
          let $this = this
          setTimeout(function () {
            $this.deleteConfirmationAlert = false
            $this.$router.go(-1)
          }, 1000)
        })
    },

    updateWO () {
      this.emitCount = 0
      if (this.updateInProgress) {
        return
      }
      this.updateInProgress = true
      if (this.primaryWorkOrder.otherDesc) {
        this.primaryWorkOrder.otherDesc = this.primaryWorkOrder.otherDesc.toUpperCase()
      }
      if (this.primaryWorkOrder.type === 'BLENDING') {
        delete this.primaryWorkOrder.structure
        delete this.primaryWorkOrder.structureTree
        console.log(JSON.stringify(this.primaryWorkOrder, null, 2))
        axios
          .post(
            process.env.VUE_APP_BACKEND + 'workorders',
            this.primaryWorkOrder
          )
          .then(response => {
            this.retrieveWorkOrder(response.data.id)
            this.updateInProgress = false
          })
        return
      }
      if (this.primaryWorkOrder.type === 'LAB TEST') {
        if (!this.primaryWorkOrder.LabTests) {
          this.primaryWorkOrder.LabTests = []
          this.primaryWorkOrder.LabTests.push({
            woid: this.primaryWorkOrder.id,
            LabResults: this.labs
          })
        } else {
          if (this.primaryWorkOrder.LabTests.length > 0) {
            this.primaryWorkOrder.LabTests[0].LabResults = this.labs
          } else {
            this.primaryWorkOrder.LabTests.push({
              woid: this.primaryWorkOrder.id,
              LabResults: this.labs
            })
          }
        }
        axios
          .post(
            process.env.VUE_APP_BACKEND + 'workorders',
            this.primaryWorkOrder
          )
          .then(response => {
            this.primaryWorkOrder = response.data.data
            this.updateInProgress = false
          })
        // if (this.deletedLabs.length > 0) {
        //   this.primaryWorkOrder.deleteLabs=this.deletedLabs
        // }
        return
      }
      // the data in dataByKey tells the backend what to add, delete or update.
      // So when this method runs for a topping it runs as a post just liek the createWO.
      //if (this.primaryWorkOrder.type === 'TOPPING') {
        // axios.put(
        //   process.env.VUE_APP_BACKEND +
        //     'workorders/' +
        //     this.primaryWorkOrder.id,
        //   this.primaryWorkOrder
        //   console.log(this.primaryWorkOrder.id)
        // )
        //   .then(response => {

        //   })

        // axios
        //   .post(
        //     process.env.VUE_APP_BACKEND + 'workorders?manageMultiLot=true',
        //     this.dataByKey
        //   )
        //   .then(response => {
        //     if (!this.primaryWorkOrder.id) {
        //       response.data.data.forEach(wo => {
        //         if (this.primaryWorkOrder.Lot.lotNumber === wo.lot) {
        //           this.primaryWorkOrder.id = wo.id
        //         }
        //       })
        //     }
        //     this.retrieveWorkOrder(this.primaryWorkOrder.id)
        //     this.updateInProgress = false
        //     // axios
        //     //   .post(process.env.VUE_APP_BACKEND+'workorders', this.primaryWorkOrder)
        //     //   .then((response) => {
        //     //     this.retrieveWorkOrder(this.primaryWorkOrder.id)
        //     //   })
        //   })
      //  return
      //}
      if (this.primaryWorkOrder.type === 'BOTTLING') {
        axios
          .post(
            process.env.VUE_APP_BACKEND + 'workorders',
            this.primaryWorkOrder
          )
          .then(response => {
            this.primaryWorkOrder = response.data.data
            this.updateInProgress = false
          })
        return
      }
      if (this.primaryWorkOrder.id) {
        // if this exists then we are modifing an existing work order
        axios
          .put(
            process.env.VUE_APP_BACKEND +
              'workorders/' +
              this.primaryWorkOrder.id,
            this.primaryWorkOrder
          )
          .then(response => {
            this.retrieveWorkOrder(this.$route.query.id)
            this.updateInProgress = false
          })
      } else {
        // ths is a new workorder that needs to be created
        axios
          .post(
            process.env.VUE_APP_BACKEND + 'workorders',
            this.primaryWorkOrder
          )
          .then(response => {
            // console.log(JSON.stringify(response.data.data))
            this.primaryWorkOrder = response.data.data
            this.updateInProgress = false
          })
      }
    },
    estimatedTonsChange (value) {
      console.log(value)
    },
    updateType (value) {
      switch (value) {
        case 'BOTTLING':
          if (!this.primaryWorkOrder.Bottlings) {
            this.primaryWorkOrder.Bottlings = []
          }
          break
        case 'BLENDING':
          if (!this.primaryWorkOrder.BlendItems) {
            this.$set(this.primaryWorkOrder, 'BlendItems', [])
          }
          break
        // case 'TOPPING':
        //   if (this.$route.params.id === '-1') {
        //     this.lotsList = []
        //     this.primaryWorkOrder.Lot.taskId = this.primaryWorkOrder.taskId
        //     this.primaryWorkOrder.Lot.isSelected = true
        //     this.primaryWorkOrder.type = value
        //     this.lotsList.push(this.primaryWorkOrder.Lot)
        //   } else {
        //     this.multiLotWorkOrders.forEach(wo => {
        //       var lot = wo.Lot
        //       lot.isSelected = true
        //       this.lotsList.push(wo.Lot)
        //     })
        //   }
        //   break
        case 'SCP':
          if (this.primaryWorkOrder.SCPs.length === 0) {
            var scpRecord = {
              estDaysInTank: 12,
              estimatedTons: 3,
              wholeCluster: 0,
              handSorting: 'YES',
              Location: {},
              id: -1,
              woid: this.primaryWorkOrder.id
            }
            this.primaryWorkOrder.SCPs.push(scpRecord)
          }
          this.updateWOType(value)
          break
        default:
          this.updateWOType(value)
      }
    },
    updateWOType (value) {
      this.primaryWorkOrder.type = value
    },
    updateStatus (value) {
      self.primaryWorkOrder.status = value
    },
    retrieveWorkOrder (id) {
      axios
        .get(process.env.VUE_APP_BACKEND + 'workorders/' + id + '?skipAnalysis')
        .then(response => {
          let $this = this
          if (!Array.isArray(response.data.data)) {
            this.primaryWorkOrder = response.data.data
            this.showLabTests = this.primaryWorkOrder.type === 'LAB TEST'
            this.loaded = true
          } else {
            this.multiLotWorkOrders = response.data.data
            this.multiLotWorkOrders.forEach(function (wo) {
              if (wo.id === id) {
                $this.primaryWorkOrder = wo
              }
            })
            this.showLabTests = false
            this.lotsList = []
            this.multiLotWorkOrders.forEach(wo => {
              wo.Lot.so2Add = wo.so2Add
              wo.Lot.toppingLot = wo.toppingLot
              wo.Lot.woId = wo.id
              wo.Lot.otherDesc = wo.otherDesc
              wo.Lot.isComplete = wo.isComplete
              wo.Lot.Client = wo.Client
              wo.Lot.isSelected = true
              wo.Lot.taskId = wo.taskId
              $this.lotsList.push(wo.Lot)
            })
            this.loaded = true
          }
          axios
            .get(process.env.VUE_APP_BACKEND + 'workorders/' + id)
            .then(response => {
              if (!Array.isArray(response.data.data)) {
                this.$set(
                  this.primaryWorkOrder,
                  'structure',
                  response.data.data.structure
                )
                this.$set(
                  this.primaryWorkOrder,
                  'previousStructure',
                  response.data.data.previousStructure
                )
                this.$set(
                  this.primaryWorkOrder,
                  'structureTree',
                  response.data.data.structureTree
                )
              } else {
                for (var i=0; i < response.data.data.length; i++) {
                  let wo = response.data.data[i]
                  console.log(JSON.stringify(wo.id, null, 2))
                  if (wo.id === this.primaryWorkOrder.id) {
                    this.$set(
                      this.primaryWorkOrder,
                      'structure',
                      wo.structure
                    )
                    this.$set(
                      this.primaryWorkOrder,
                      'previousStructure',
                      wo.previousStructure
                    )
                    this.$set(
                      this.primaryWorkOrder,
                      'structureTree',
                      wo.structureTree
                    )
                  }
                }
              }
            })
        })
    }
  },
  watch: {
    // this is called anytime a main field is touched.
    primaryWorkOrder: {
      handler: function (nv, ov) {
        this.emitCount++ // normally emit count is incremented by 1 when first loaded if lab test or topping so test
      },
      deep: true // is to see if emitCount>1 so I just setting to 10 here
    },
    globalChange: function (nv, ov) {
      this.$router.push({
        path: '/lots'
      })
    }
  },
  computed: {
    description: {
      set: function (val) {
        this.primaryWorkOrder.otherDesc = utf8.encode(val)
        console.log(this.primaryWorkOrder.otherDesc)
      },
      get: function () {
        return clean(this.primaryWorkOrder.otherDesc)
      }
    },
    completionCommentsExist () {
      if (this.primaryWorkOrder.completionDescription) {
        return (
          this.primaryWorkOrder.completionDescription !== null &&
          this.primaryWorkOrder.completionDescription !== ''
        )
      } else {
        return false
      }
    },
    selectedLotsCount () {
      return this.multiLotWorkOrders.length
    },
    darkTheme () {
      if (this.primaryWorkOrder.type === 'BLENDING') {
        return false
      }
      return true
    },
    estimatedTons: {
      get: function () {
        return this.primaryWorkOrder.SCPs[0].estimatedTons
      },
      set: function (value) {
        this.primaryWorkOrder.SCPs[0].estimatedTons = value
      }
    },
    estDaysInTank: {
      get: function () {
        return this.primaryWorkOrder.SCPs[0].estDaysInTank
      },
      set: function (value) {
        this.primaryWorkOrder.SCPs[0].estDaysInTank = value
      }
    },
    sulphurPPM: {
      get: function () {
        return this.primaryWorkOrder.SCPs[0].sulphurPPM
      },
      set: function (value) {
        this.primaryWorkOrder.SCPs[0].sulphurPPM = value
      }
    },
    globalChange () {
      return (
        JSON.stringify(this.$store.state.user) +
        JSON.stringify(this.$store.state.client) +
        this.$store.state.vintage
      )
    },
    vintage () {
      return this.$store.state.vintage
    },
    lots () {
      return this.$store.state.lotsForVintage
    },
    id () {
      return this.$route.query.id
    }
  }
}
</script>
<style scoped>
textarea {
  margin-left: auto;
  margin-right: auto;
}
td {
  border: 1px solid gray;
}
.lotSelect {
  width: 400px;
}
.sub-title-right {
  text-align: right;
}
.clientSelect {
  width: 100px;
}
.box-card {
  width: 480px;
}
</style>
